import { createFileRoute } from "@tanstack/react-router"
import { FeedOverviewWithId } from "../-components/FeedOverviewWithId"

export const Route = createFileRoute("/app/com/feeds/$feedId/")({
  component: FeedOverviewWithId,
  beforeLoad: () => ({
    getTitle: undefined,
  }),
})
